export const candidates = [
  "Annatar",
  "enroutemarcel12",
  "LeBienHeureux",
  "Shinoa",
  "Raditzytb",
  "Shemale",
  "123pourquoi",
  "Vorony",
  "Juju13",
  "mei123",
  "Tachenko"
]
